/**
 * Wall-clock label for the most recent poll, shared so widgets sitting side by
 * side read the same way. Eastern Time because that is the market's clock.
 */
const lastUpdatedFormatter = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit",
  timeZone: "America/New_York",
});

export const formatLastUpdatedAt = (
  value: number | undefined,
): string | undefined =>
  value && Number.isFinite(value)
    ? `Last updated ${lastUpdatedFormatter.format(value)} ET`
    : undefined;
